// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const lpbTestimoniesSlider = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
        this.bindSlider();
    },

    bindUI: function() {
        this.ui.sliders = document.querySelectorAll(".js-lpbTestimoniesSlider");
    },

    bindEvents: function() {},

    bindSlider: function() {
        const sliderParams = {
            slidesPerView: 2,
            spaceBetween: 20,
            containerModifierClass: 'js-lpbTestimoniesSlider',
            wrapperClass: 'js-lpbTestimoniesSlider-wrapper',
            slideClass: 'js-lpbTestimoniesSlider-slide',
            navigation: {
                nextEl: '.js-lpbTestimoniesSlider-nav-next',
                prevEl: '.js-lpbTestimoniesSlider-nav-prev',
            },
            pagination: {
                el: '.js-lpbTestimoniesSlider-pagination',
                clickable: true,
                // dynamicBullets: true,
            },
            breakpoints: {
                100: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: false,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
        };
        this.ui.sliders.forEach(slider => {
            // If we have multiple js-lpbTestimoniesSlider on the landing page we must use the same system as in photoGallery.js

            new Swiper(slider, sliderParams);
        });
    },
};

export default lpbTestimoniesSlider;